// | ------------------------------------------------------------------------
// | Scrollbars
// | ------------------------------------------------------------------------

//? https://kingsora.github.io/OverlayScrollbars/
import { OverlayScrollbars } from "overlayscrollbars"; // Used in /components/shop/productFilters

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var homeProdItems = document.querySelectorAll(".home-prod-item .nav");

  homeProdItems.forEach((homeProdItem) => {
    OverlayScrollbars(homeProdItem, {
      overflow: {
        x: "hidden",
      },
    });
  });

  var dropdownGrids = document.querySelectorAll(".dropdown-grid");

  dropdownGrids.forEach((dropdownGrid) => {
    OverlayScrollbars(dropdownGrid, {
      overflow: {
        x: "hidden",
      },
    });
  });

  var dropdownTabPanes = document.querySelectorAll(".nav-prod-pane .nav");

  dropdownTabPanes.forEach((dropdownTabPane) => {
    OverlayScrollbars(dropdownTabPane, {
      overflow: {
        x: "hidden",
      },
    });
  });

  var downloadPanes = document.querySelectorAll(".download-list");

  downloadPanes.forEach((downloadPane) => {
    OverlayScrollbars(downloadPane, {
      overflow: {
        x: "hidden",
      },
    });
  });
});
